import React from "react";
import PartInstallationComponentPage from "./PartInstallationComponentPage";


const ProductionPage = (props) => {


    return <>


        <PartInstallationComponentPage
        />

    </>;
}

export default ProductionPage;

